import { Alert, Box, Chip, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { elencaInvii, type Invio } from './email.api'

const NESSUNO: Invio[] = []

const ETICHETTA: Record<Invio['stato'], string> = {
  in_coda: 'In coda',
  inviata: 'Inviata',
  errore: 'Non inviata',
}

const COLORE: Record<Invio['stato'], 'default' | 'success' | 'error'> = {
  in_coda: 'default',
  inviata: 'success',
  errore: 'error',
}

export function LogEmail() {
  const { data: invii = NESSUNO, error } = useQuery({
    queryKey: ['invii-email'],
    queryFn: () => elencaInvii(),
    // Un invio in coda diventa «inviata» in pochi secondi.
    refetchInterval: (q) => (q.state.data?.some((i) => i.stato === 'in_coda') ? 5000 : false),
  })

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Email inviate
      </Typography>
      {error && <Alert severity="error" role="alert" sx={{ mb: 2 }}>{error instanceof Error ? error.message : 'Errore nel caricamento'}</Alert>}
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Data</TableCell>
            <TableCell>Destinatario</TableCell>
            <TableCell>Oggetto</TableCell>
            <TableCell>Modello</TableCell>
            <TableCell>Esito</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invii.map((i) => (
            <TableRow key={i.id}>
              <TableCell>{new Date(i.creatoIl).toLocaleString('it-IT')}</TableCell>
              <TableCell>{i.destinatario}</TableCell>
              <TableCell>{i.oggetto}</TableCell>
              <TableCell>{i.chiave}</TableCell>
              <TableCell>
                <Chip size="small" label={ETICHETTA[i.stato]} color={COLORE[i.stato]} />
                {i.errore !== null && (
                  <Typography variant="caption" color="error" sx={{ display: 'block' }}>
                    {i.errore}
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {invii.length === 0 && <p>Nessuna email inviata</p>}
    </Box>
  )
}
